module.exports = __webpack_public_path__ + "static/media/logo.522fa59e.png";